// extracted by mini-css-extract-plugin
export default {"root":"GuidelineCard_root__7Jk0y","active":"GuidelineCard_active__s-NnN","pending":"GuidelineCard_pending__HVsQa","expired":"GuidelineCard_expired__Xcufw"};